/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import PropTypes from "prop-types";
import Salert from "react-s-alert";
import tipsImg from "tips-icon.png";

import {
  mobile_rule,
  phone_code_rule,
  buildRules,
} from "@shared/scripts/utils/validation_rules";
import CustomizeInput from "../shared/CustomizeInput";
import CustomizeSelect from "../shared/CustomizeSelect";
import FormWrapper from "../utils/FormWrapper";

const TIME = 60;
// eslint-disable-next-line no-unused-vars
let captcha;
const getInstance = instance => {
  captcha = instance;
};
// 实名表单
class SmForm extends React.Component {
  state = {
    isSend: false,
    time: TIME,
    // src: "/rucaptcha/",
  };

  componentDidMount() {
    const layer = document.createElement("div");
    layer.className = "wait-del";
    layer.style.cssText = `position: fixed;
    top: 0;
    left: 0;
    width: ${document.body.clientWidth < 1025 ? "80px" : "100%"};
    height: ${document.body.clientWidth < 1025 ? "80px" : "100%"};
    background-color: transparent;
    z-index: ${document.body.clientWidth < 1025 ? 100 : 99};;
    cursor: pointer;`;
    layer.addEventListener(
      "click",
      () => {
        $.ajax({
          url: "/logout",
          type: "GET",
          dataType: "json",
          success: res => {
            console.log(res);
            window.location.reload();
          },
        });
      },
      false
    );
    document.body.appendChild(layer);
    // 只用初始化一次验证码即可
    window.initAliyunCaptcha({
      SceneId: "nepl2ukj", // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: "mk2426", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: "#captcha-button", // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: this.captchaVerifyCallback.bind(this), // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: this.onBizResultCallback.bind(this), // 业务请求结果回调函数，无需修改
      getInstance: getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 320,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
  }

  componentWillUnmount() {
    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    document.getElementById("aliyunCaptcha-mask")?.remove();
    document.getElementById("aliyunCaptcha-window-popup")?.remove();
  }

  async captchaVerifyCallback(captchaVerifyParam) {
    let result = {};
    let error = false;
    try {
      result = await this.sendCodeCore(captchaVerifyParam);
    } catch (e) {
      error = e;
    }

    console.log("result:", result);

    if (error) {
      Salert.error(error.responseJSON.errors[0]);
      captcha.refresh();
      captcha.hide();
    } else {
      return {
        captchaResult: result.captchaResult, // 验证码验证是否通过，boolean类型，必选 result.captchaVerifyResult
        bizResult: result.bizResult, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
      };
    }
  }

  // 验证通过后调用
  onBizResultCallback(bizResult) {
    console.log("bizResult:", bizResult);
  }

  // safari 某些版本中 这里 直接改src state 不能正确触发 view update
  // 排查出是safari图片缓存机制的问题 加时间戳解决
  // updateRucaptcha() {
  //   this.setState({
  //     src: "/rucaptcha/?" + Date.now(),
  //   });
  // }

  sendCodeCore(captchaVerifyParam) {
    return new Promise((resolve, reject) => {
      const {
        data: { mobile },
      } = this.props;

      if (!this.state.isSend) {
        $.ajax({
          url: "/mobile_verify_code/verify_code",
          method: "POST",
          datType: "json",
          headers: {
            "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
          },
          data: {
            captchaVerifyParam,
            mobile: mobile.value,
          },
          success: res => {
            const timer = setInterval(() => {
              if (this.state.time === 0) {
                clearInterval(timer);
                this.setState({
                  isSend: false,
                  time: TIME,
                });
                // this.updateRucaptcha();
              }
              this.setState({
                time: this.state.time - 1,
              });
            }, 1000);
            this.setState({
              isSend: true,
            });
            resolve(res);
          },
          error: xhr => {
            console.log(xhr.status, xhr.responseJSON);
            reject(xhr);
            // this.updateRucaptcha();
          },
        });
      }
    });
  }

  verifyMobile() {
    const {
      data: { mobile },
    } = this.props;

    if (!mobile.value || !mobile.valid) {
      Salert.error("手机号不合法!");
    }
  }

  submit() {
    if (!this.props.isFormValidate()) {
      console.error("表单验证未通过");
      return false;
    }

    const $form = $(this.refs.smForm);
    $form.ajaxSubmit({
      url: $form.attr("action"),
      type: "POST",
      dataType: "json",
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      },
      success: res => {
        if (res.success) {
          Salert.success("成功");
          // this.props.setSm(true);
          document.querySelector(".wait-del").style.zIndex = -1;
          if (res.redirect) {
            window.location.href = res.redirect;
          } else {
            window.location.reload();
          }
        }
      },
      error: e => {
        Salert.error(e.responseJSON.errors[0]);
        // this.updateRucaptcha();
      },
    });
  }

  render() {
    const {
      data: { mobile, phone_verify_code, profession, working_years },
      changeValue,
    } = this.props;
    const { isSend, time } = this.state;

    return (
      <form
        ref="smForm"
        action="/settings/mobile/verified"
        className="sm-form"
        onKeyDown={e => {
          if (e.which === 13) this.submit();
        }}
      >
        <CustomizeInput
          {...mobile}
          onChange={value => {
            changeValue(value, "mobile");
          }}
        />
        <div className="u-code">
          <CustomizeInput
            {...phone_verify_code}
            onChange={value => {
              changeValue(value, "phone_verify_code");
            }}
          />
          {(!mobile.value || !mobile.valid || isSend) && (
            <div
              className={`captcha-layer ${isSend && "captcha-layer--done"}`}
              onClick={() => this.verifyMobile()}
            />
          )}
          <div
            id="captcha-button"
            className={`send-code ${isSend && "send-code--done"}`}
          >
            {isSend ? `${time}s 重新获取` : "获取短信验证码"}
          </div>
          <div id="captcha-element" />
        </div>
        <p className="sm-modal__tips">
          <img src={tipsImg} alt="tips" />
          根据国家法律规要求,绑定手机号获得更高级的安全保护
        </p>
        <CustomizeInput
          {...profession}
          onChange={value => {
            changeValue(value, "profession");
          }}
        />
        <CustomizeSelect
          {...working_years}
          options={[
            {
              label: "1 年内",
              value: "1年内",
            },
            {
              label: "1-3 年",
              value: "1-3年",
            },
            {
              label: "3-5 年",
              value: "3-5年",
            },
            {
              label: "5 年以上",
              value: "5年以上",
            },
          ]}
          onChange={value => {
            changeValue(value, "working_years");
          }}
        />
        <a
          className="u-btn--black signin-form__submit"
          href="javascript:;"
          alt="提交"
          style={{ marginBottom: "40px" }}
          onClick={() => {
            this.submit();
          }}
        >
          提交
        </a>
      </form>
    );
  }
}

SmForm.propTypes = {
  setSm: PropTypes.func.isRequired,
  isFormValidate: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  changeValue: PropTypes.func.isRequired,
};

export default FormWrapper({
  mobile: buildRules("mobile_verify[mobile]", "手机号码", [mobile_rule]),
  phone_verify_code: buildRules("mobile_verify[phone_verify_code]", "验证码", [
    phone_code_rule,
  ]),
  profession: buildRules("mobile_verify[profession]", "职业", []),
  working_years: buildRules("mobile_verify[working_years]", "从业年限", []),
})(SmForm);
